import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Villa from "@/pages/Villa";
import Services from "@/pages/Services";
import Events from "@/pages/Events";
import Contact from "@/pages/Contact";
import Seniors from "@/pages/Seniors";
import SejourFamille from "@/pages/SejourFamille";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/villa/:slug" element={<Villa />} />
        <Route path="/services" element={<Services />} />
        <Route path="/seniors" element={<Seniors />} />
        <Route path="/sejour-famille" element={<SejourFamille />} />
        <Route path="/events" element={<Events />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Layout>
  );
}

function AppRoutes() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    );
  }
  return <PublicRoutes />;
}

export default function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}
